import { Tooltip } from "antd";
import React from "react";
import { color } from "theme/aiInventory";

// Keyframes are registered in theme.ts (injected once by AiInventory root).

const dotStyle: React.CSSProperties = {
  display: "inline-block",
  width: 10,
  height: 10,
  background: color.integration,
  borderRadius: "50%",
  animation: "p0-live-pulse 2.4s ease-out infinite",
  border: `2px solid ${color.card}`,
  flexShrink: 0,
};

export const LiveDot: React.FC<{ label?: string }> = ({
  label = "Live session",
}) => (
  <Tooltip title={label}>
    <span aria-label={label} style={dotStyle} />
  </Tooltip>
);
